import styled from 'styled-components'

export default styled.div`
  flex-direction: row;
  flex: 1;
`



// WEBPACK FOOTER //
// ./src/components/WidgetPicker/WidgetPickerRow/Main.js